import { BrowserRouter, Navigate, Route, Routes as Router } from "react-router-dom";
import PresentationsPage from "./pages/Presentations";
import LoginPage from "./pages/LoginPage";
import { useContext } from "react";
import AppContext from "./utils/Auth";
import ViewUsersPage from "./pages/ViewUsers";
import ResetPassword from "./pages/ResetPassword";
import ForgotPassword from "./pages/ForgotPassword";
import VerifyLoginLink from "./pages/VerifyLoginLink";
import GeneratePresentation from "./pages/GeneratePresentation";
import IndexPage from "./pages/IndexPage";
import LearningObjectivesAndTagsPage from "./pages/LearningObjectivesAndTags";
import MyPresentations from "./pages/MyPresentations";

const Routes = (): JSX.Element => {
  const { isAuthenticated, hasRole} = useContext(AppContext);

  const PrivateAdminRoutes = () => {
    if(isAuthenticated && hasRole(["sudo", "admin", "system-admin"])) {
      return (
        <Router>
          {/* <Route path="/" element={<IndexPage />} /> */}
          <Route path="/verify" element={<VerifyLoginLink />} />
          <Route path="/users" element={<ViewUsersPage />} />
          <Route path="/presentations" element={<PresentationsPage />} />
          <Route path="/learning-objectives-tags" element={<LearningObjectivesAndTagsPage />} />
        </Router>
      )
    } else {
      return null
    }
  }

  const PrivateRoutes = () => {
    if(isAuthenticated) {
      return (
        <Router>
            <Route path="/" element={<IndexPage />} />
            <Route path="/verify" element={<VerifyLoginLink />} />
            <Route path="/generate" element={<GeneratePresentation />} />
            <Route path="/my-presentations" element={<MyPresentations />} />
        </Router>
      )
    } else {
      return null
    }
  }

  return (
    <BrowserRouter>
        {isAuthenticated ? (
          <>
            <PrivateRoutes />
            <PrivateAdminRoutes />
          </>
        ) : (
          <Router>
            <Route path="/" element={<LoginPage />} />
            <Route path="/verify" element={<VerifyLoginLink />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:jwt" element={<ResetPassword />} />
            <Route path="/set-password/:jwt" element={<ResetPassword />} />
            <Route path="*" element={<Navigate to="/" />}/>
          </Router>
        )}

    </BrowserRouter>
  );
};

export default Routes;
